import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPagination } from 'src/app/shared/models/pagination';
import { environment } from 'src/environments/environment';
import { IipObservation } from '../interfaces/Iip-observation';
import { Rendition } from '../interfaces/Iip-rendition';
import FilterValues from '../interfaces/ip-filter-values';
import { PageResponse } from '../interfaces/ip-page-response';
import { PaymentProof } from '../interfaces/ip-payment-proof';
import RenditionDTO from '../interfaces/ip-rendition-dto';
import RenditionResponse from '../interfaces/ip-rendition-response';
import { NeWRendition } from '../interfaces/lip-new-renditions';
import { QueryParametersService } from './ip-query-parameter.service';

@Injectable({
  providedIn: 'root',
})
export class IpTableSurrenderService {
  api = environment.api;

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService
  ) { }

  getData(
    type: string,
    pagination: IPagination,
    sortFieldName: string = 'creationDate',
    sortOrder: string = 'desc',
    searchName: string = '',
    searchValue: string = '',
    filterValues: FilterValues,
    statusId: number,
    onlyReportedBills: boolean = false,
    ignoredTypeStatus?: number,
  ): Observable<PageResponse<RenditionResponse>> {
    const params = this.queryParameterService.buildQueryParameters(
      sortFieldName,
      sortOrder,
      pagination,
      searchName,
      searchValue,
      filterValues,
      statusId,
      ignoredTypeStatus,
    );
    if (onlyReportedBills) {
      return this.http.get<PageResponse<RenditionResponse>>(
        `${this.api}/invopay/renditions?reported=true`,
        { params }
      );
    }
    else if (type === 'business') {
      return this.http.get<PageResponse<RenditionResponse>>(
        `${this.api}/invopay/renditions?reported=false`,
        { params }
      );
    }
    else if (type === 'employee') {
      return this.http.get<PageResponse<RenditionResponse>>(
        `${this.api}/invopay/renditions`,
        { params }
      );
    }
    else {
      console.warn('Unexpected user kind.');
      return this.http.get<PageResponse<RenditionResponse>>(
        `${this.api}/invopay/renditions`,
        { params }
      );
    }
  }

  getRenditionById(id: number): Observable<RenditionDTO> {
    return this.http.get<RenditionDTO>(`${this.api}/invopay/renditions/${id}`);
  }

  getRenditionObservations(id: number): Observable<IipObservation[]> {
    return this.http.get<IipObservation[]>(
      `${this.api}/invopay/observations/rendition/${id}`
    );
  }

  createRenditionObservation(renditionId: number, description: string) {
    return this.http.post<IipObservation>(
      `${this.api}/invopay/observations/rendition?renditionId=${renditionId}`,
      { description }
    );
  }

  updateRenditionStatus(id: number, typeStatusId: number) {
    return this.http.patch(
      `${this.api}/invopay/renditions/${id}?newFlowStatusId=${typeStatusId}`,
      {}
    );
  }

  payRendition(request: PaymentProof): Observable<PaymentProof> {
    const formattedBody = this.toFormData(request);
    return this.http.post<PaymentProof>(
      `${this.api}/invopay/renditions/pay`,
      formattedBody
    );
  }

  // TODO: Fix and rename all these methods:

  deleteRenditions(id: number): Observable<Object> {
    return this.http.delete(`${this.api}/invopay/renditions/${id}`);
  }

  getRenditionsId(id: number): Observable<Rendition> {
    return this.http.get<Rendition>(`${this.api}/invopay/renditions/${id}`);
  }

  reportInvoice(id: number): Observable<Object> {
    return this.http.put(`${this.api}/invopay/renditions/${id}`, {});
  }

  createRendicion(request: NeWRendition): Observable<NeWRendition> {
    return this.http.post<NeWRendition>(`${this.api}/invopay/renditions`, request)
  }

  toFormData(formValue: any) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      if (key === 'balance') {
        formData.append(`${key}.taxId`, value.taxId);
        formData.append(`${key}.amount`, value.amount);
      } else {
        formData.append(key, value);
      }
    }
    return formData;
  }
}
